export default "__VITE_ASSET__PysLE57C__"